/* eslint-disable import/no-unresolved */
import { HeaderBackButton, HeaderBackButtonProps } from '@react-navigation/elements';
import { useMemo } from 'react';
import { I18nManager, Platform, StyleSheet } from 'react-native';
import Svg, { Path } from 'react-native-svg';

import { tID } from 'app/services/TestHelper';

const styles = StyleSheet.create({
  icon: {
    height: 21,
    width: 13,
    marginLeft: 8,
    marginRight: 8,
    marginVertical: 12,
    transform: [{ scaleX: I18nManager.getConstants().isRTL ? -1 : 1 }],
  },
  iconWithLabel: {
    marginRight: 6,
  },
});

export default function CustomHeaderBackButton(props: HeaderBackButtonProps) {
  const getBackImage = useMemo(() => {
    return Platform.OS === 'ios'
      ? ({ tintColor }: { tintColor: string }) => (
          // Vector chevron (same shape as the old back-icon.png) so it draws synchronously.
          // On iOS 26 the header bar item does not repaint when an async image load
          // finishes, which left an empty Liquid Glass circle until the next re-render.
          <Svg
            fill="none"
            style={[
              styles.icon,
              // Only an explicit label mode adds the gap, as `labelVisible` did before v7.
              (props.displayMode === 'default' || props.displayMode === 'generic') &&
                styles.iconWithLabel,
            ]}
            viewBox="0 0 13 21"
          >
            <Path
              d="M11.5 1.5L2.5 10.5L11.5 19.5"
              stroke={tintColor}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
            />
          </Svg>
        )
      : undefined;
  }, [props.displayMode]);

  return <HeaderBackButton {...props} backImage={getBackImage} testID={tID('BackButton')} />;
}
